if (typeof Turbo!= 'undefined') {
  window.addEventListener("turbo:load", init_content_pages);
  window.addEventListener("turbo:frame-load", init_content_pages);
} else {
  window.addEventListener("load", init_content_pages);
}

export function init_content_pages(event) {
  const html= (event.currentTarget) ? event.currentTarget.document : event
  bind_content_pages_helpers(html);
}

function bind_content_pages_helpers(html= document) {
  /* Connector Name Select dropdown in ContentPage Options */
  const contentPageConnectorNameElm= html.querySelector('#content_page_connector_name');
  if (contentPageConnectorNameElm) {
    contentPageConnectorNameElm.addEventListener("change", function(event) {
      /* Copy value to redirect_url field */
      // console.log(event.currentTarget.value);
      const redirectUrlElm= document.querySelector('#content_page_link_url')
      if (redirectUrlElm) {
        redirectUrlElm.value= event.currentTarget.value;
      }
    });
  }
}
